module.exports = __webpack_public_path__ + "img/88.a1f0fd3a.jpg";